// reacttour/StartTour.js - from logistics-workflow: desktop steps, adapted for phones (menu steps added)
import { useTour } from "@reactour/tour";
import { TABS } from "../pages/tabs";

const isMobile = () => window.innerWidth < 768;          // as MobileContext

// Nav tab IDs that only exist in the desktop tab bar (pages/MainPage.js TABS).
// On mobile they're hidden behind the hamburger menu; their mobile equivalents are #mobile-{tab}.
const NAV_TAB_IDS = new Set(TABS.map((t) => `#${t.key}`));

function makeOpenMenuStep(toggleSelector, label) {
  return {
    selector: toggleSelector,
    position: "bottom",
    advanceOn: toggleSelector,
    hideFooter: true,
    _mobileInjected: true,
    content: () => (
      <div style={{ maxWidth: "min(88vw, 340px)" }}>
        <h3 style={{ margin: 0, marginBottom: 6 }}>Open the menu</h3>
        <p style={{ margin: 0 }}>
          Tap <strong>{label}</strong> to expand the navigation, then we'll continue.
        </p>
      </div>
    ),
  };
}

export function adaptStepsForViewport(steps) {
  if (!isMobile()) return steps;

  const result = [];
  for (const step of steps) {
    const sel = step.selector;

    if (sel && NAV_TAB_IDS.has(sel)) {
      // Inject "open hamburger" step, then remap selector to #mobile-{tab}
      result.push(makeOpenMenuStep("#mobile-menu-toggle", "the menu button"));
      result.push({
        ...step,
        selector: sel.replace(/^#/, "#mobile-"),
        position: "bottom",
        advanceOn: step.advanceOn
          ? step.advanceOn.replace(/^#/, "#mobile-")
          : undefined,
      });

    } else if (step.position === "right" || step.position === "left") {
      result.push({ ...step, position: "bottom" });

    } else {
      result.push(step);
    }
  }
  return result;
}

export const useStartTour = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const startTour = (steps) => {
    setCurrentStep(0);
    setSteps(adaptStepsForViewport(steps));
    setTimeout(() => setIsOpen(true), 0);
  };

  return startTour;
};

